// src/api/authApi.js
import { getApi } from './axiosInstance';

// Register new user
export const register = async (email, password) => {
    try {
        const response = await getApi().post('/auth/register', {
            email,
            password
        });
        return response.data;
    } catch (error) {
        console.error('Registration error:', error);
        throw error;
    }
};

// Login function
export const login = async (email, password) => {
    try {
        const response = await getApi().post('/auth/login', {
            email,
            password
        });
        
        if (response.data && response.data.token) {
            // Store the token
            localStorage.setItem('authToken', response.data.token);
            return response.data;
        }
        throw new Error('No token received from server');
    } catch (error) {
        console.error('Login error:', error);
        throw error;
    }
};

// Verify token
export const verifyToken = async () => {
    try {
        const response = await getApi().get('/auth/verify');
        return response.data;
    } catch (error) {
        console.error('Token verification error:', error);
        throw error;
    }
};

// Logout function
export const logout = () => {
    localStorage.removeItem('authToken');
    // You might want to call a server endpoint to invalidate the token
    // await getApi().post('/auth/logout');
};